(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exa-footer"] && !Shopify.designMode) return;
  try {
    
  const syncExaFooterMenus = () => {
    document.querySelectorAll('.exa-footer').forEach((footer) => {
      const isStacked = window.matchMedia('(max-width: 989px)').matches;
      footer.querySelectorAll('.exa-footer__menu').forEach((menu, index) => {
        menu.open = !isStacked || index === 0;
      });
    });
  };

  syncExaFooterMenus();
  window.addEventListener('resize', syncExaFooterMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exa-hero-slider"] && !Shopify.designMode) return;
  try {
    
  const HERO_VIDEO_DELAY = 1000;
  const HERO_DESKTOP_QUERY = '(min-width: 750px)';

  const startDeferredHeroVideo = (stage) => {
    const video = stage.querySelector('[data-exa-hero-video]');
    if (!(video instanceof HTMLVideoElement) || video.dataset.exaLoaded === 'true') return;
    if (!window.matchMedia(HERO_DESKTOP_QUERY).matches) return;

    const source = video.querySelector('source[data-src]');
    if (source instanceof HTMLSourceElement) {
      source.src = source.dataset.src || '';
      source.removeAttribute('data-src');
    }

    video.dataset.exaLoaded = 'true';
    video.load();

    const showVideo = () => {
      stage.classList.add('is-video-playing');
    };

    video.addEventListener('playing', showVideo, { once: true });
    video.play().catch(() => {
      stage.classList.remove('is-video-playing');
    });
  };

  const initDeferredHeroVideo = (stage) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window.setTimeout(() => {
      startDeferredHeroVideo(stage);
    }, HERO_VIDEO_DELAY);
  };

  document.querySelectorAll('[data-exa-hero-stage]').forEach((stage) => {
    if (stage instanceof HTMLElement) {
      initDeferredHeroVideo(stage);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exa-newsletter-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initNewsletterModals = () => {
      document.querySelectorAll('[data-exa-newsletter-modal]').forEach((component) => {
        if (component.dataset.exaNewsletterInitialized === 'true') return;
        component.dataset.exaNewsletterInitialized = 'true';

        component.addEventListener('dialog:open', () => {
          window.setTimeout(() => {
            const response = component.querySelector('[data-exa-newsletter-response]');
            const email = component.querySelector('[data-exa-newsletter-email]');
            const target = response || email;

            if (target instanceof HTMLElement) {
              target.focus({ preventScroll: true });
            }
          }, 80);
        });

        if (component.querySelector('[data-exa-newsletter-response]')) {
          customElements.whenDefined('dialog-component').then(() => {
            if (typeof component.showDialog === 'function') {
              component.showDialog();
            }
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNewsletterModals, { once: true });
    } else {
      initNewsletterModals();
    }

    document.addEventListener('shopify:section:load', initNewsletterModals);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
